import { jsx } from '@amzn/shiv'
import { createAbortSlot, debounce, logDebug, withAbort } from '@amzn/vinyl-util'
import { ctx } from '@/util/context'
import { createSearchRecommender, type SearchSpecification } from '@/search/searchService'
import type { SearchRecommender } from '@/search/SearchRecommender'
import { PartyResultItem } from './PartyResultItem'

const { target, errorHandler } = ctx('PartySearch')

const SEARCH_SPECIFICATIONS: SearchSpecification[] = [
    { label: 'TopResults', types: ['album', 'artist', 'playlist', 'track', 'station'], limit: 4 },
    { label: 'Albums', types: ['album'], limit: 4 },
    { label: 'Artists', types: ['artist'], limit: 4 },
    { label: 'Songs', types: ['track'], limit: 4 },
]

const searchRecommender: SearchRecommender = createSearchRecommender(SEARCH_SPECIFICATIONS)

export function PartySearch() {
    const resultsContainer = <div className="partyResults" />
    const abortSlot = createAbortSlot()

    const searchInput = (
        <input
            className="partySearchInput"
            type="search"
            placeholder="Search for songs..."
            onfocus={(e) => (e.target as HTMLInputElement).select()}
        />
    ) as HTMLInputElement

    const doSearch = () => {
        const q = searchInput.value
        logDebug(target, 'Searching q=', q)
        abortSlot.abort()
        resultsContainer.innerHTML = ''
        if (!q.trim()) return

        withAbort(searchRecommender({ query: q }), abortSlot.value)
            .then((results) => {
                const seen = new Set<string>()
                const items = results
                    .flatMap((g) => g.items)
                    .filter((item) => {
                        if (!item.id || seen.has(item.id)) return false
                        seen.add(item.id)
                        return true
                    })
                resultsContainer.innerHTML = ''
                if (!items.length) {
                    resultsContainer.append(<p className="noResults">No results found</p>)
                    return
                }
                items.forEach((item) => resultsContainer.append(<PartyResultItem data={item} />))
            })
            .catch(errorHandler)
    }

    searchInput.oninput = debounce(doSearch, 0.4)

    return (
        <div className="partySearch" onConnect={() => () => abortSlot.abort()}>
            <div className="searchBarContainer">{searchInput}</div>
            {resultsContainer}
        </div>
    )
}
